module.exports = __webpack_public_path__ + "img/card-2.90308167.png";